export const CSS_CLASSES = {
  TEXT_HEADING_01: "text-heading-01",
  TEXT_HEADING_02: "text-heading-02",
  TEXT_HEADING_03: "text-heading-03",
  TEXT_HEADING_04: "text-heading-04",
  TEXT_HEADING_05: "text-heading-05",
  TEXT_HEADING_06: "text-heading-06",
  TEXT_BODY_SHORT: "text-body-short",
  TEXT_BODY_LONG: "text-body-long",
  TEXT_CAPTION: "text-caption",
  TEXT_LABEL: "text-label",
  TEXT_HELPER_TEXT: "text-helper-text",
  TEXT_PRIMARY: "text-primary",
  TEXT_SECONDARY: "text-secondary",
  TEXT_INTERACTIVE: "text-interactive",
  TEXT_ACCENT: "text-accent",
  TEXT_GRAY: "text-gray",
  TEXT_ERROR: "text-error",
  TEXT_WARNING: "text-warning",
  TEXT_SUCCESS: "text-success",
  TEXT_WHITE: "text-white",
  TEXT_BLACK: "text-black",
  TEXT_CURRENTCOLOR: "text-currentcolor",
};
